import { Box, Divider, Typography } from "@mui/material";

const DateDivider = ({ date }: { date: string }) => (
  <Box sx={styles.container}>
    <Divider orientation="horizontal" sx={styles.divider} />
    <Typography component="span" sx={styles.date}>
      {date}
    </Typography>
    <Divider orientation="horizontal" sx={styles.divider} />
  </Box>
);

export default DateDivider;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  date: {
    color: "var(--Gray-600, #475467)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  divider: {
    flex: 1,
    borderColor: "var(--Gray-200, #EAECF0)",
  },
};
